import { getAudioFileExtension } from '@components/AudioRecorder/AudioRecorder';

import { AudioAttachment, AutopsyActBrief } from '@/api/pathology/types';
import { UUID } from '@/shared/api/types';
import { OrganizationLevelType } from '@/shared/organizations/enums';
import { AutopsySource } from '@/shared/pathology/enums';
import { Auth } from '@/shared/security/hasPermission';
import DateMapper, { DateTimeFormat } from '@/utils/dateUtils';

// Пока идёт обработка записи, список и карточка акта опрашиваются с этим интервалом
export const PROCESSING_POLLING_INTERVAL = 5000;

/**
 * Хозяйство, в котором работает пользователь: выбранное в меню/фильтре (?organizationId=),
 * а без выбора — своё (для структурного подразделения — родительское хозяйство).
 */
export const resolveActsOrganizationId = (
  auth: Auth,
  queryOrganizationId?: string | null,
): UUID | undefined => {
  if (queryOrganizationId) return queryOrganizationId;

  switch (auth?.organization?.level) {
    case OrganizationLevelType.ORGANIZATION:
      return auth.organization.id;
    case OrganizationLevelType.STRUCTURAL_DIVISION:
      return auth.organization.parentId;
    default:
      return undefined;
  }
};

export interface AudioSourceValues {
  source?: AutopsySource;
  audio?: File;
  recording?: Blob;
}

// Файл записи из формы: загруженный файл или запись с микрофона, в зависимости от источника
export const toAudioAttachment = ({
  source,
  audio,
  recording,
}: AudioSourceValues): AudioAttachment | undefined => {
  if (source === AutopsySource.UPLOAD && audio) {
    return { file: audio, fileName: audio.name };
  }
  if (source === AutopsySource.RECORD && recording) {
    return {
      file: recording,
      fileName: `recording.${getAudioFileExtension(recording.type)}`,
    };
  }
  return undefined;
};

export const formatDate = (value?: string | null) =>
  value ? DateMapper(value).format(DateTimeFormat.DATE) : '';

export const formatDateTime = (value?: string | null) =>
  value ? DateMapper(value).format(DateTimeFormat.DATE_TIME_SHORT) : '';

export const getAutopsyActFileName = (
  act: Pick<AutopsyActBrief, 'individualInventoryNumber' | 'performedAt'>,
) =>
  ['Акт вскрытия', act.individualInventoryNumber, formatDate(act.performedAt)]
    .filter(Boolean)
    .join(' ') + '.pdf';
